/**
 * Meta Pixel Tracking Utility
 * Provides helper functions for tracking conversions and events
 */

// Check if fbq is available
const isFbqAvailable = () => typeof window !== 'undefined' && typeof window.fbq === 'function';

/**
 * Track a page view
 */
export const trackPageView = () => {
  if (isFbqAvailable()) {
    window.fbq('track', 'PageView');
  }
};

/**
 * Track when a user starts a visa application
 */
export const trackInitiateCheckout = (data = {}) => {
  if (isFbqAvailable()) {
    window.fbq('track', 'InitiateCheckout', {
      content_name: data.visaType || 'Visa Application',
      content_category: 'Visa Services',
      currency: 'AED',
      value: data.value || 0,
      ...data
    });
  }
};

/**
 * Track when a user completes a visa application form
 */
export const trackCompleteRegistration = (data = {}) => {
  if (isFbqAvailable()) {
    window.fbq('track', 'CompleteRegistration', {
      content_name: data.visaType || 'Visa Application',
      status: 'submitted',
      currency: 'AED',
      value: data.value || 0,
      ...data
    });
  }
};

/**
 * Track a successful purchase/payment
 */
export const trackPurchase = (data = {}) => {
  if (isFbqAvailable()) {
    window.fbq('track', 'Purchase', {
      content_name: data.visaType || 'Visa Application',
      content_type: 'visa',
      content_ids: data.applicationId ? [data.applicationId] : [],
      currency: 'AED',
      value: data.value || 0,
      num_items: data.numItems || 1,
      ...data
    });
  }
};

/**
 * Track a lead (e.g., contact form submission, inquiry)
 */
export const trackLead = (data = {}) => {
  if (isFbqAvailable()) {
    window.fbq('track', 'Lead', {
      content_name: data.source || 'Website',
      content_category: 'Visa Inquiry',
      ...data
    });
  }
};

/**
 * Track when user adds to cart (starts application)
 */
export const trackAddToCart = (data = {}) => {
  if (isFbqAvailable()) {
    window.fbq('track', 'AddToCart', {
      content_name: data.visaType || 'Visa Application',
      content_type: 'visa',
      content_ids: data.applicationId ? [data.applicationId] : [],
      currency: 'AED',
      value: data.value || 0,
      ...data
    });
  }
};

/**
 * Track custom events
 */
export const trackCustomEvent = (eventName, data = {}) => {
  if (isFbqAvailable()) {
    window.fbq('trackCustom', eventName, data);
  }
};

/**
 * Track B2B agent application submission
 */
export const trackB2BApplication = (data = {}) => {
  if (isFbqAvailable()) {
    window.fbq('track', 'Lead', {
      content_name: 'B2B Visa Application',
      content_category: 'B2B Services',
      currency: 'AED',
      value: data.value || 0,
      lead_type: 'b2b_application',
      ...data
    });
  }
};

export default {
  trackPageView,
  trackInitiateCheckout,
  trackCompleteRegistration,
  trackPurchase,
  trackLead,
  trackAddToCart,
  trackCustomEvent,
  trackB2BApplication
};
